import { render } from "./MessageOptionComponent.vue?vue&type=template&id=8e1498a4"
import script from "./MessageOptionComponent.vue?vue&type=script&lang=js"
export * from "./MessageOptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__